import React from 'react';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import TableComponent from '../../../../Component/TableComponent/TableComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid2 as Grid, IconButton, Tooltip } from '@mui/material';
import ButtonComponent from '../../../../Component/ButtonComponent/ButtonComponent';
import { initFormHandler } from '../../../../Handler/FormHandler';
import TextFieldComponent from '../../../../Component/TextFieldComponent/TextFieldComponent';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';
import { TableReload } from "../../../../Reducer/TableReducer/TableSlice";
import { Delete, Edit } from '@mui/icons-material';
import Swal from "sweetalert2";

function AdministratorRoleList(props) {
    const [loadingContent, setLoadingContent] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [showDialog, setShowDialog] = React.useState(false);
    const [row, setRow] = React.useState(null);
    const columns = [
        {
            name: "id",
            label: "Référence",
            options: { filter: true, sort: true }
        },
        {
            name: "description",
            label: "Description",
            options: { filter: true, sort: true }
        },
        {
            name: "action",
            label: "Action",
            options: { filter: false, sort: false }
        }
    ];
    const [form, setForm] = React.useState({
        id: {
            name: "id",
            label: "Référence",
            textHelper: "Référence",
            type: "text",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        description: {
            name: "description",
            label: "Description",
            textHelper: "Description",
            type: "text",
            defaultValue: "",
            options: {},
        },
    });
    const handlerForm = initFormHandler(form, setForm);
    React.useEffect(() => {
        handlerForm.start();
    }, [handlerForm]);

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Administrateur',
            context: 'Liste des rôles',
            description: '',
            links: []
        });
        setTimeout(() => {
            setLoadingContent(false);
        }, 1500);
    }, []);

    const getAction = (row) => {
        return (
            <>
                <div style={{ display: 'flex' }}>
                    <Tooltip title={"Éditer"} placement="left" arrow>
                        <IconButton
                            onClick={() => {
                                setShowDialog(true);
                                setRow(row);
                                handlerForm.setDataApi(row);
                            }}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Supprimer"} placement="left" arrow>
                        <IconButton
                            onClick={() => {
                                Swal.fire({
                                    title: "Êtes-vous sûr ?",
                                    text: "La suppression sera definitive.",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#87bba4",
                                    cancelButtonColor: "var(--greytext)",
                                    confirmButtonText: "Confirmer",
                                    cancelButtonText: "Annuler",
                                    reverseButtons: true,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        ApiHandler.delete(
                                            {
                                                route: "administrator_role_delete",
                                                params: row ? { id: row.id } : "",
                                            },
                                            (response) => {
                                                if (response.status === 200) {
                                                    dispatch(TableReload("administrator_role_list"));
                                                    dispatch(
                                                        SnackbarOpen({
                                                            text: "Rôle supprimé avec succès",
                                                            variant: "success",
                                                        }),
                                                    );
                                                } else {
                                                    dispatch(
                                                        SnackbarOpen({
                                                            text:
                                                                response.error && response.error.message
                                                                    ? response.error.message
                                                                    : "Une erreur inattendu s'est produite.",
                                                            variant: "error",
                                                        }),
                                                    );
                                                }
                                            },
                                        );
                                    }
                                });
                            }}>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </div>
            </>
        );
    };

    const save = () => {
        if (handlerForm.checkError() < 1) {
            setLoading(true);
            handlerForm.setFormLoading(true);
            ApiHandler.post(
                {
                    route: row ? "administrator_role_edit" : "administrator_role_add",
                    params: row ? { id: row.id } : "",
                    data: handlerForm.getData(),
                },
                (response) => {
                    if (response.status === 200 || response.status === 201) {
                        dispatch(TableReload("administrator_role_list"));
                        dispatch(
                            SnackbarOpen({
                                text: row ? "Rôle modifié avec succès" : "Rôle crée avec succès",
                                variant: "success",
                            }),
                        );
                        setShowDialog(false);
                        setRow(null);
                    } else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                    }
                    handlerForm.setFormLoading(false);
                    setLoading(false);
                },
            );
        }
    }

    return (
        <ContentViewComponent loading={loadingContent} breadcrumbs={breadcrumbs}>
            <TableComponent
                id={'administrator_role_list'}
                title={'Rôle'}
                columns={columns}
                mobileMode={'cards'}
                actionFirst={{
                    label: "Ajouter un rôle",
                    onClick: () => {
                        setShowDialog(true);
                        setRow(null);
                        handlerForm.reset();
                    },
                }}
                promiseData={(resolve) => {
                    ApiHandler.get({ route: 'administrator_role_list' },
                        (response) => {
                            if (response.status === 200) {
                                let data = response.data;
                                for (let index in data) {
                                    data[index].action = getAction(data[index]);
                                }
                                resolve(data);
                            } else {
                                resolve([]);
                            }

                        });
                }}
            />

            <Dialog open={showDialog} maxWidth={"xl"} onClose={() => setShowDialog(false)}>
                <DialogTitle style={{ fontSize: 15 }}>
                    {row ? "Édition" : "Ajout"} rôle {row ? "Référence: " + row.id : ""}
                </DialogTitle>
                <DialogContent style={{ minWidth: "40vw" }}>
                    <Grid container spacing={1}>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
                            <TextFieldComponent id={"id"} handler={handlerForm} disabled={row ? true : false} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
                            <TextFieldComponent id={"description"} handler={handlerForm} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonComponent
                        loading={loading}
                        color={"var(--greytext)"}
                        label={"Annuler"}
                        onClick={() => setShowDialog(false)}
                    />
                    <ButtonComponent label={"Enregistrer"} onClick={save} />
                </DialogActions>
            </Dialog>

        </ContentViewComponent>
    );
}

export default AdministratorRoleList;
